/* eslint-disable react/no-unescaped-entities */
import { config } from '@thisisdevelopment/akzonobel-core';
import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import styled from 'styled-components';

const Page = styled.main`
  padding: 40px 10%;
`;

const FormWrapper = styled.div`
  height: 1000px;
  margin-top: 80px;

  > iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;

const LanguageDropDown = styled.div`
  select {
    padding: 8px 10px;
    border-radius: 4px;
  }
`;
const Notice = styled.div`
  ul {
    list-style: none;
    padding: 0;
  }
  li {
    padding-bottom: 8px;
  }
  a {
    color: #012169;
    font-family: 'Source Sans Pro', sans-serif;
    text-underline-position: under;
    font-weight: 600;
    font-size: 1.1em;
  }
`;

function PrivacyPolicy() {
  const [otNoticeApiLoaded, setOtNoticeApiLoaded] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (otNoticeApiLoaded) {
        clearInterval(interval);
      }
      if (typeof window.OneTrust.NoticeApi.Initialized !== 'undefined') {
        setOtNoticeApiLoaded(true);
        window.OneTrust.NoticeApi.Initialized.then(function () {
          window.OneTrust?.NoticeApi.LoadNotices(
            [
              'https://privacyportalde-cdn.onetrust.com/24527c35-1de1-4aaa-833d-de50b42446bd/privacy-notices/a58effe7-5173-4f06-a9a9-ec6180250fc1.json',
            ],
            true,
            config.language
          );
        });
      }
    }, 200);
    return () => clearInterval(interval);
  }, [otNoticeApiLoaded]);

  return (
    <HelmetProvider>
      <Helmet>
        <script
          src="https://privacyportalde-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js"
          id="otprivacy-notice-script"
        >
          settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1kZS5vbmV0cnVzdC5jb20vcmVxdWVzdC92MS9wcml2YWN5Tm90aWNlcy9zdGF0cy92aWV3cyJ9"
        </script>
      </Helmet>
      <Page title="Privacy Policy">
        <LanguageDropDown className="otnotice-language-dropdown-container">
          <select id="otnotice-language-dropdown" aria-label="language selector"></select>
        </LanguageDropDown>
        <Notice id="otnotice-a58effe7-5173-4f06-a9a9-ec6180250fc1" className="otnotice" />
        <FormWrapper className="ot-form-wrapper">
          <iframe
            title="Privacy Policy"
            src="https://privacyportal-de.onetrust.com/webform/24527c35-1de1-4aaa-833d-de50b42446bd/8c650df7-a9c9-4780-a173-e91886e285fa"
          ></iframe>
        </FormWrapper>
      </Page>
    </HelmetProvider>
  );
}

export default PrivacyPolicy;
